import { gsap } from "gsap";
gsap.registerPlugin(ScrollTrigger);

console.log('top');


const btns = document.querySelectorAll('.mv-btn');
const mores = document.querySelectorAll('.mv-con-more');
const icons = document.querySelectorAll('.mv-btn-icon');
let isOpen = false;

btns.forEach((btn, index) => {
    btn.addEventListener('click', function () {
        //mores[index].classList.toggle('active');
        icons[index].classList.toggle('active');

        const more = mores[index];
        const open = more.classList.contains('active');

        if (!open) {
            more.style.transition = 'all 1s ease-out';
            more.classList.add('active');
            more.style.maxHeight = more.scrollHeight + 'px';
        } else {
            more.style.transition = 'all 1s ease-in-out';
            more.style.maxHeight = '0px';
            more.classList.remove('active');
        }
    });
});

const width = window.innerWidth;
const buttons = document.querySelectorAll('.mv');
const links = document.querySelectorAll('.thumbnail');
const modal = document.querySelectorAll('.modal');
const videos = document.querySelectorAll('.video');
const closes = document.querySelectorAll('.close-btn');

videos.forEach((video) =>{
    if(width <= 768){
        video.style.width = width * 0.8 + 'px';
    } else {
        video.style.width = width * 0.5 + 'px';
        video.style.maxWidth = 1000 + 'px';
    }

    buttons.forEach((btn, index) =>{
        btn.addEventListener('click', function(){
            const mvId = links[index].getAttribute('data-movie-id');
            video.src = `https://www.youtube.com/embed/${mvId}?autoplay=1&mute=1`;
            modal.forEach((modal) =>{
                modal.classList.add('active');
            });
        });
    });
});

modal.forEach((modal)=>{
    modal.addEventListener('click', (event) =>{
        if(event.target.closest('.video') === null){
            modal.classList.remove('active');
        }
    });
});


closes.forEach((close) =>{
    if(width <= 768){
        const btnw = close.clientWidth;
        console.log(btnw);
        close.style.right = '-' + btnw + 'px';
        close.style.top = '-' + btnw + 'px' ;
    }
});


const top = document.querySelectorAll('.top-mv');

var tl = gsap.timeline();
var mm = gsap.matchMedia();

tl.to('.top-ttl', {
    //alpha: 0,
    y: '-70vh',
    scrollTrigger: {
        trigger: top,
        start: 'center center',
        end: '+=800',
        scrub: true
    }
});
tl.to('.top-text', {
    alpha: 1,
    scrollTrigger: {
        trigger: top,
        start: '+=800',
        end: '+=500',
        scrub: true
    }
})
gsap.to('.bg-box', {
    alpha: .4,
    scrollTrigger: {
        pin: true,
        trigger: top,
        start: 'center center',
        end: '+=1500',
        scrub: true
    }
});